<div
    cdkDropList
    [cdkDropListDisabled]="
        disabled() || draggingRequirement() || draft.draggingDocument()
    "
    (cdkDropListDropped)="dropSection($event)"
    class="grid grid-cols-1 gap-4"
>
    @for (group of draft.groups(); track group.key; let sectionIndex = $index) {
        <section
            cdkDrag
            [cdkDragDisabled]="
                disabled() || draggingRequirement() || draft.draggingDocument()
            "
            (pointerdown)="captureSectionHeight($event)"
            class="section-card overflow-hidden rounded-[var(--qpx-radius-base)] border border-border bg-card text-card"
            [attr.aria-label]="group.name"
        >
            <div
                *cdkDragPlaceholder
                class="drop-placeholder text-body-lg font-semibold"
                [qpxDropSurface]="{ state: 'valid', context: 'primary' }"
                [style.height.px]="sectionPlaceholderHeight()"
            >
                Place section here
            </div>
            <qpx-quippy-pack-section-heading
                [smallHeaders]="smallHeaders()"
                [actionId]="actionId()"
                [group]="group"
                [sectionIndex]="sectionIndex"
                [last]="$last"
                [disabled]="disabled()"
                (removed)="removeSection(group.key)"
                (changed)="changed.emit()"
            />
            <div
                class="column-headings uppercase border-t border-border px-7 py-2"
            >
                <span qpxColHeader>Requirement</span
                ><span qpxColHeader>Assigned documents</span>
            </div>
            <div
                cdkDropList
                [id]="`${actionId()}-requirements-${group.key}`"
                [cdkDropListData]="group.key"
                [cdkDropListConnectedTo]="listIds()"
                [cdkDropListDisabled]="disabled() || draft.draggingDocument()"
                (cdkDropListDropped)="dropRow($event)"
                class="grid min-w-0 grid-cols-1 divide-y divide-border border-t border-border"
            >
                @for (row of group.rows; track row.id; let rowIndex = $index) {
                    <article
                        cdkDrag
                        [cdkDragData]="row.id"
                        [cdkDragDisabled]="
                            disabled() || draft.draggingDocument()
                        "
                        [cdkDragStartDelay]="{ touch: 180, mouse: 0 }"
                        (pointerdown)="captureRequirementHeight($event)"
                        (cdkDragStarted)="draggingRequirement.set(true)"
                        (cdkDragEnded)="draggingRequirement.set(false)"
                        class="min-w-0 bg-card py-3 text-card"
                        [attr.aria-label]="row.name"
                    >
                        <div
                            *cdkDragPlaceholder
                            class="drop-placeholder text-body-lg font-semibold"
                            [qpxDropSurface]="{
                                state: 'valid',
                                context: 'primary',
                            }"
                            [style.height.px]="requirementPlaceholderHeight()"
                        >
                            Place requirement here
                        </div>
                        <qpx-quippy-pack-requirement-editor
                            [smallHeaders]="smallHeaders()"
                            [actionId]="actionId()"
                            [row]="row"
                            [group]="group"
                            [rowIndex]="rowIndex"
                            [disabled]="disabled()"
                            (changed)="changed.emit()"
                        />
                    </article>
                } @empty {
                    <p
                        [qpxDropSurface]="
                            draggingRequirement() && !disabled()
                                ? { state: 'valid', context: 'primary' }
                                : null
                        "
                        class="m-0 p-4 text-body-md text-muted"
                    >
                        No requirements. Add one below or drag a requirement
                        here.
                    </p>
                }
            </div>
            <div class="border-t border-border px-7 py-2">
                <button
                    qpxButton
                    matButton="outlined"
                    size="sm"
                    class="justify-self-start"
                    [disabled]="disabled()"
                    (click)="addRequirement(group.key)"
                >
                    <ng-icon
                        qpx
                        size="sm"
                        name="lucidePlus"
                        matButtonIcon
                    /><span>Add requirement</span>
                </button>
            </div>
        </section>
    }
</div>

<button
    qpxButton
    matButton="outlined"
    size="sm"
    class="justify-self-start"
    [disabled]="disabled()"
    (click)="addSection()"
>
    <ng-icon qpx size="sm" name="lucidePlus" matButtonIcon /><span
        >Add section</span
    >
</button>
<qpx-quippy-pack-excluded-documents
    [actionId]="actionId()"
    [disabled]="disabled()"
    (changed)="changed.emit()"
/>
